import InternalRequestNotificationsEventCatcher from '../../../../realTimeApi/eventCatchers/internalRequest/InternalRequestNotificationsEventCatcher';
import InternalRequestNotificationDescriptionUtils from './InternalRequestNotificationDescriptionUtils';
import InternalRequestModel from '../../../../api/models/InternalRequestModel';
import PATH from '../../../../routes/paths';
import {
  projectIdPattern,
  internalRequestIdPattern,
} from '../../../../routes/replacePatterns';
import NotificationModel from '../../../../api/models/NotificationModel';

/* eslint default-case: 0 */
/* eslint no-param-reassign: 0 */

const replaceProjectId = (path, projectId) => {
  return path.replace(projectIdPattern, projectId);
};

const replaceInternalRequestId = (path, internalRequestId) => {
  return path.replace(internalRequestIdPattern, internalRequestId);
};

/**
 *
 * @param {NotificationModel} notificationModel
 */
const setInternalRequestNotificationMissingFields = (notificationModel) => {
  /** FYI: this function applies model's setters  */

  const getDescriptionFunc =
    InternalRequestNotificationDescriptionUtils
      .IR_MESSAGE_GETTERS_BY_UPDATE_TYPE[notificationModel.notificationType];

  const {
    internalRequestId,
    internalRequestType,
    projectId,
    requesterFirstName,
    requesterLastName,
    rejectionReason,
  } = notificationModel.metadata;

  const path = replaceInternalRequestId(
    replaceProjectId(PATH.PROJECT.INTERNAL_REQUEST.ONE, projectId),
    internalRequestId
  );

  const requesterName = `${requesterFirstName} ${requesterLastName}`;

  const typeI18nKey = InternalRequestModel.READABLE_TYPE[internalRequestType];
  const typeName = typeI18nKey
    ? { text: typeI18nKey, withTranslate: true }
    : `Internal Request #${internalRequestId}`;

  const setType = (type) => {
    notificationModel.notificationUiType = type;
  };

  const setResourceMetaData = () => {
    notificationModel.resourceMetaData = {
      resourceId: internalRequestId,
      resourceType: 'internalRequest',
      path,
      projectId,
    };
  };

  const setDescription = (description) => {
    notificationModel.description = description;
  };

  const setName = (name) => {
    notificationModel.name = name;
  };

  const NOTIFICATIONS_CONFIG = {
    [InternalRequestNotificationsEventCatcher.IR_UPDATE_TYPES
      .IR_CREATED]: () => {
      setType(NotificationModel.NOTIFICATION_TYPES.CREATE);
      setResourceMetaData();
      setDescription(getDescriptionFunc(requesterName, internalRequestType));
      setName(typeName);
    },
    [InternalRequestNotificationsEventCatcher.IR_UPDATE_TYPES
      .IR_SUBMITTED]: () => {
      setType(NotificationModel.NOTIFICATION_TYPES.CREATE);
      setResourceMetaData();
      setDescription(getDescriptionFunc(requesterName, internalRequestType));
      setName(typeName);
    },
    [InternalRequestNotificationsEventCatcher.IR_UPDATE_TYPES
      .IR_APPROVED]: () => {
      setType(NotificationModel.NOTIFICATION_TYPES.UPDATE);
      setResourceMetaData();
      setDescription(
        getDescriptionFunc(internalRequestId, internalRequestType)
      );
      setName(typeName);
    },
    [InternalRequestNotificationsEventCatcher.IR_UPDATE_TYPES
      .IR_REJECTED]: () => {
      setType(NotificationModel.NOTIFICATION_TYPES.UPDATE);
      setResourceMetaData();
      setDescription(
        getDescriptionFunc(
          internalRequestId,
          rejectionReason,
          internalRequestType
        )
      );
      setName(typeName);
    },
    [InternalRequestNotificationsEventCatcher.IR_UPDATE_TYPES
      .IR_PENDING_CLOSED]: () => {
      setType(NotificationModel.NOTIFICATION_TYPES.UPDATE);
      setResourceMetaData();
      setDescription(
        getDescriptionFunc(internalRequestId, internalRequestType)
      );
      setName(typeName);
    },
    [InternalRequestNotificationsEventCatcher.IR_UPDATE_TYPES
      .IR_CLOSED]: () => {
      setType(NotificationModel.NOTIFICATION_TYPES.UPDATE);
      setResourceMetaData();
      setDescription(
        getDescriptionFunc(internalRequestId, internalRequestType)
      );
      setName(typeName);
    },
  };

  const action = NOTIFICATIONS_CONFIG[notificationModel.notificationType];

  action();

  return notificationModel;
};

export default setInternalRequestNotificationMissingFields;
